// Taken from https://github.com/lukeed/dequal/blob/master/src/lite.js
const has = Object.prototype.hasOwnProperty;

// using lite version of `dequal` for comparing following types:
// Number, String, Date, RegExp, Object, Array, Class
// eslint-disable-next-line max-statements
export function isEqual(value1, value2): boolean {
  let ctor; let
    len;

  if (value1 === value2) { return true; }

  if (value1 && value2 && (ctor = value1.constructor) === value2.constructor) {
    if (ctor === Date) { return value1.getTime() === value2.getTime(); }
    if (ctor === RegExp) { return value1.toString() === value2.toString(); }

    if (ctor === Array) {
      if ((len = value1.length) !== value2.length) {
        return false;
      }

      while (len > 0) {
        len -= 1;
        if (!isEqual(value1[len], value2[len])) {
          return false;
        }
      }

      return true;
    }

    if (!ctor || typeof value1 === 'object') {
      len = 0;
      for (ctor in value1) {
        len += 1;
        if (has.call(value1, ctor) && len && !has.call(value2, ctor)) { return false; }
        if (!(ctor in value2) || !isEqual(value1[ctor], value2[ctor])) { return false; }
      }

      return Object.keys(value2).length === len;
    }
  }

  // eslint-disable-next-line no-self-compare
  return value1 !== value1 && value2 !== value2;
}
